import { createSections, createVersionFields, ISelectionOption, IUpdateMapping, updateBySelection, updateField, updateSection, updateSections, updateVersion, updateVersionFields } from ".";
import { ISourceDataConfigurationFormVersion } from '@/api/dtos';

export const ConfigurationUpdateVersionMapping: IUpdateMapping = {
    createOptions: (source, target) => {
        let options: ISelectionOption[] = [
            {
                name: 'options',
                label: 'Options',
                options: [
                    {
                        name: 'overrideName',
                        label: 'Override Name',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormVersion).name = (sourceValue as ISourceDataConfigurationFormVersion).name;
                        }
                    },
                    {
                        name: 'priority',
                        label: 'Priority',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormVersion).priority = (sourceValue as ISourceDataConfigurationFormVersion).priority;
                        }
                    },
                    {
                        name: 'excludeBlank',
                        label: 'Hide Version When No Data Provided',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormVersion).excludeBlank = (sourceValue as ISourceDataConfigurationFormVersion).excludeBlank;
                        }
                    },
                    {
                        name: 'alerts',
                        label: 'Alerts',
                        options: [
                            {
                                name: 'information',
                                label: 'Information',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormVersion).alertInformation = (sourceValue as ISourceDataConfigurationFormVersion).alertInformation;
                                }
                            },
                            {
                                name: 'warning',
                                label: 'Warning',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormVersion).alertWarning = (sourceValue as ISourceDataConfigurationFormVersion).alertWarning;
                                }
                            },
                            {
                                name: 'error',
                                label: 'Error',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormVersion).alertError = (sourceValue as ISourceDataConfigurationFormVersion).alertError;
                                }
                            },
                            {
                                name: 'success',
                                label: 'Success',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormVersion).alertSuccess = (sourceValue as ISourceDataConfigurationFormVersion).alertSuccess;
                                }
                            }
                        ]
                    }
                ]
            }
        ];

        if (source.formVersionMetadata?.sections && source.formVersionMetadata.sections.length !== 0) {
            options.push({
                name: 'sections',
                label: 'Sections',
                options: source.formVersionMetadata.sections.map(x => ({
                    name: x.id!,
                    label: `${x.name}`,
                    update: (source, target, sourceValue, targetValue, newValue) => {
                        const typedNewValue = (newValue as ISourceDataConfigurationFormVersion);
                        const typedTargetValue = (targetValue as ISourceDataConfigurationFormVersion);
                        const typedSourceValue = (sourceValue as ISourceDataConfigurationFormVersion);
                        
                        if (!typedNewValue.linked) {
                            createSections(typedSourceValue, typedTargetValue, typedNewValue, target.formVersionMetadata)
                        }

                        typedNewValue.sections = {...typedNewValue.sections};
                        updateSection(typedSourceValue, typedTargetValue, typedNewValue, x.id!, target.formVersionMetadata);
                    }
                }))
            });
        }

        if (source.formVersionMetadata?.fields && source.formVersionMetadata.fields.length !== 0) {
            const versionFieldMetadata = source.formVersionMetadata.fields.filter(x => !x.formSectionMetadataId);

            if (versionFieldMetadata.length !== 0) {
                options.push({
                    name: 'fields',
                    label: 'Fields',
                    options: versionFieldMetadata.map(x => ({
                        name: x.id!,
                        label: `${x.name}`,
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            const typedNewValue = (newValue as ISourceDataConfigurationFormVersion);
                            const typedTargetValue = (targetValue as ISourceDataConfigurationFormVersion);
                            const typedSourceValue = (sourceValue as ISourceDataConfigurationFormVersion);
                            
                            if (!typedNewValue.linked) {
                                createVersionFields(typedSourceValue, typedTargetValue, typedNewValue, target.formVersionMetadata)
                            }

                            typedNewValue.fields = {...typedNewValue.fields};
                            updateVersionFields(typedSourceValue, typedTargetValue, typedNewValue, target.formVersionMetadata);
                        }
                    }))
                });
            }
        }

        return options;
    },
    update: (source, target, sourceValue, targetValue, options, selection) => {
        const newValue = { 
            ...targetValue,
            linked: sourceValue.linked
        };

        updateBySelection(source, target, sourceValue, targetValue, newValue, options, selection);

        return newValue;
    }
}